import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useCallback } from 'react';

export const useReCaptchaToken = () => {
  // Tenta obter o hook do reCAPTCHA
  // Se o provider não estiver disponível, executeRecaptcha será undefined
  let executeRecaptcha: ((action: string) => Promise<string>) | undefined;
  
  try {
    const recaptcha = useGoogleReCaptcha();
    executeRecaptcha = recaptcha?.executeRecaptcha;
  } catch (error) {
    // Provider não está disponível - isso acontece se REACT_APP_RECAPTCHA_SITE_KEY não estiver configurada
    // ou se o componente não estiver dentro do GoogleReCaptchaProvider
    executeRecaptcha = undefined;
  }

  const getReCaptchaToken = useCallback(async (): Promise<string | null> => {
    // Se o reCAPTCHA não estiver disponível, retorna null (não bloqueia o login)
    if (!executeRecaptcha) {
      return null;
    }

    try {
      const token = await executeRecaptcha('login');
      return token || null;
    } catch (error: any) {
      // Erro ao executar reCAPTCHA - não bloqueia o login
      console.warn('⚠️ Erro ao executar reCAPTCHA:', error?.message || error);
      return null;
    }
  }, [executeRecaptcha]);

  return { getReCaptchaToken };
};

